import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import {
  EmployeeTaxFormsMetadata,
  getEmployeeTaxFormsProgress
} from "./getEmployeeTaxFormsProgress";

/**
 * Status pill (+ progress secondary text) for an EmployeeTaxForms requirement,
 * shared by the payer and payee cell configs. Prefer the requirement's
 * effective `status` — it reflects a sticky payer override (payerOverrideStatus
 * from applyPayerOverrides), so the pill must not show "Complete" right after
 * the payer marked the requirement incomplete. Fall back to `dataSourceStatus`
 * (all forms submitted) when no effective status is present.
 */
export const getEmployeeTaxFormsStatusCell = (
  requirement: PayeeRequirement,
  metadata: EmployeeTaxFormsMetadata
) => {
  const status = requirement.status ?? requirement.dataSourceStatus;
  if (status === RequirementStatus.COMPLETED) {
    return {
      pill: { text: "Complete", theme: "success" as const, icon: true }
    };
  }
  const progress = getEmployeeTaxFormsProgress(metadata);
  return {
    // "Action required" (not "Pending") — the ball is in the payee's court
    // (design-review call, provisionally applied pending product sign-off).
    pill: { theme: "warning" as const, text: "Action required", icon: true },
    secondaryText: progress.label || undefined
  };
};
